import { LngLat, LngLatLike } from 'mapbox-gl'

import { IProjectAddressInput } from '~/client/graph'
import { IMapBoxFeature } from '~/client/src/shared/interfaces/IMapBoxFeature'
import { toAddressBoundsInput } from '~/client/src/shared/utils/Address'

const MAPBOX_COUNTRY = 'country'
const MAPBOX_POSTCODE = 'postcode'
const MAPBOX_PLACE = 'place'
const MAPBOX_REGION = 'region'
const MAPBOX_BASE_URL = 'https://api.mapbox.com/geocoding/v5/mapbox.places/'
const DEFAULT_RADIUS_METERS = 100

export const getMapBoxUrl = (
  query: string,
  token: string,
  addTypes: boolean,
  proximity?: LngLatLike,
): string => {
  const lngLat = proximity ? LngLat.convert(proximity) : null

  return `${MAPBOX_BASE_URL}${query}.json?access_token=${token}${
    addTypes ? '&types=address,place' : ''
  }${lngLat ? `&proximity=${lngLat.lng},${lngLat.lat}` : ''}`
}

export function mapboxFeatureToAddress(
  item: IMapBoxFeature,
): IProjectAddressInput {
  const [lng, lat] = item?.center || []

  if (lng === undefined || lat === undefined) {
    const worldCenter = new LngLat(0, 0)

    return {
      address: '',
      city: '',
      state: '',
      zipcode: '',
      country: '',
      bounds: toAddressBoundsInput(worldCenter.toBounds(DEFAULT_RADIUS_METERS)),
      center: worldCenter,
      bearing: 0,
      projectId: null,
    }
  }

  const context = item.context || []
  const center = new LngLat(lng, lat)
  const isPlace = item.place_type?.includes(MAPBOX_PLACE)
  const isCountry = item.place_type?.includes(MAPBOX_COUNTRY)
  const featureName = item.text || item.place_name?.split(',')[0] || ''

  const countryProp = context.find(i => i.id.startsWith(MAPBOX_COUNTRY))
  const postCodeProp = context.find(i => i.id.startsWith(MAPBOX_POSTCODE))
  const placeProp = context.find(i => i.id.startsWith(MAPBOX_PLACE))
  const regionProp = context.find(i => i.id.startsWith(MAPBOX_REGION))
  const state = regionProp
    ? regionProp.short_code
      ? regionProp.short_code.split('-')[1]
      : regionProp.text
    : ''

  return {
    address: item.place_name?.split(',')[0] || '',
    city: isPlace ? featureName : placeProp?.text || '',
    state,
    zipcode: postCodeProp?.text || '',
    country: isCountry ? featureName : countryProp?.text || '',
    bounds: toAddressBoundsInput(center.toBounds(DEFAULT_RADIUS_METERS)),
    center,
    bearing: 0,
    projectId: null,
  }
}
